// extracted by mini-css-extract-plugin
export default {"form":"profile_form__c9gh8","inputBlock":"profile_inputBlock__nGUPz","handlersBlock":"profile_handlersBlock__uK2Nc"};